import { render, staticRenderFns } from "./WidgetCaptcha.vue?vue&type=template&id=0b9d30b8"
import script from "./WidgetCaptcha.vue?vue&type=script&lang=ts"
export * from "./WidgetCaptcha.vue?vue&type=script&lang=ts"
import style0 from "./WidgetCaptcha.vue?vue&type=style&index=0&id=0b9d30b8&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FieldWrapper: require('/builds/project/wyffest/frontend/components/field/FieldWrapper.vue').default})
